      <!-- Banner Demonstrativo de debito anual -->
       <section class="banner-debitos">
        <div class="banner-debitos-container">

          <div class="banner-debitos-icone">
            <img src="assets/images/irpf.png" alt="Demonstrativo de Débitos Quitados">
          </div>

          <div class="banner-debitos-texto">
            <h2>Demonstrativo de Quitação de Débitos disponível</h2>
            <p>
              Acesse o documento com o resumo dos débitos referentes ao ano de {{ dados.anoBase }}.
            </p>
          </div>

          <div class="banner-debitos-acao">
            <button class="btn-baixar" type="button" (click)="onBaixar()">
              Baixar Demonstrativo
            </button>
          </div>

        </div>
      </section>